export default __webpack_public_path__ + "static/media/memories.3a0addb2.png";